import { useQuery } from '@tanstack/react-query';

import { getRoles } from '../../api/roles.api';

/**
 * Hook to fetch all roles with lazy loading support.
 * No pagination needed - returns complete list.
 *
 * @param enabled - Whether to enable the query (default: true). Set to false for lazy loading.
 */
export const useRoles = (enabled = true) => {
  return useQuery({
    queryKey: ['roles'],
    queryFn: getRoles,
    staleTime: 10 * 60 * 1000, // 10 minutes
    enabled,
  });
};
